export type WordDescriptionGenreId =
  | "daily"
  | "food"
  | "nature"
  | "culture"
  | "custom";

export type WordDescriptionGenre = {
  id: WordDescriptionGenreId;
  label: string;
  emoji: string;
  description: string;
  accentColor: "primary" | "secondary" | "success" | "warning";
  settingsOnly?: boolean;
};

export type WordDescriptionItem = {
  id: string;
  genreId: WordDescriptionGenreId;
  word: string;
};

export type CustomWordDescriptionItem = WordDescriptionItem & {
  createdAt: number;
};

export const wordDescriptionGenres: WordDescriptionGenre[] = [
  {
    id: "daily",
    label: "일상",
    emoji: "🏠",
    description: "물건, 장소, 행동처럼 누구나 쉽게 떠올릴 수 있는 제시어",
    accentColor: "primary",
  },
  {
    id: "food",
    label: "음식",
    emoji: "🍽️",
    description: "재료, 메뉴, 간식처럼 맛있는 이야기가 이어지는 제시어",
    accentColor: "warning",
  },
  {
    id: "nature",
    label: "자연·과학",
    emoji: "🌌",
    description: "동물, 자연 현상, 우주와 과학에 관한 제시어",
    accentColor: "success",
  },
  {
    id: "culture",
    label: "문화·취미",
    emoji: "🎬",
    description: "영화, 음악, 스포츠와 여가 생활에 관한 제시어",
    accentColor: "secondary",
  },
  {
    id: "custom",
    label: "커스텀",
    emoji: "⚙️",
    description: "설정에서 직접 추가한 제시어만 사용하는 전용 장르",
    accentColor: "secondary",
    settingsOnly: true,
  },
];

const wordsByGenre: Record<WordDescriptionGenreId, string[]> = {
  daily: [
    "우산", "엘리베이터", "도서관", "알람", "지갑", "세탁기",
    "신호등", "편의점", "달력", "택배", "거울", "지하철",
    "냉장고", "칫솔", "학교", "병원", "버스", "휴대폰",
    "책상", "의자", "창문", "계단", "리모컨", "가방",
    "시계", "공원", "자전거", "횡단보도", "우체국", "약국",
    "청소기", "선풍기", "컴퓨터", "열쇠", "마트", "침대",
  ],
  food: [
    "김치찌개", "피자", "붕어빵", "아이스크림", "떡볶이", "초밥",
    "라면", "수박", "커피", "샌드위치", "팝콘", "삼겹살",
    "비빔밥", "치킨", "김밥", "파스타", "만두", "냉면",
    "케이크", "햄버거", "된장찌개", "갈비", "쿠키", "우동",
    "샐러드", "도넛", "카레", "토스트", "족발", "마카롱",
    "오므라이스", "순대", "딸기", "감자튀김", "호떡", "잡채",
  ],
  nature: [
    "우주", "화산", "무지개", "펭귄", "사막", "번개",
    "공룡", "태풍", "산호초", "은하수", "개미", "폭포",
    "태양", "달", "지진", "북극", "고래", "나비",
    "구름", "바다", "숲", "별자리", "블랙홀", "해바라기",
    "돌고래", "오로라", "중력", "로봇", "현미경", "유전자",
    "빙하", "낙타", "문어", "소나기", "동굴", "혜성",
  ],
  culture: [
    "영화관", "축구", "노래방", "캠핑", "마술", "웹툰",
    "콘서트", "사진", "보드게임", "발레", "드라마", "놀이공원",
    "야구", "농구", "수영", "등산", "낚시", "요리",
    "독서", "그림", "피아노", "기타", "뮤지컬", "박물관",
    "여행", "게임", "볼링", "스케이트", "서핑", "요가",
    "오페라", "만화", "라디오", "축제", "태권도", "뜨개질",
  ],
  custom: [],
};

export const wordDescriptionItems: WordDescriptionItem[] = Object.entries(
  wordsByGenre,
).flatMap(([genreId, words]) =>
  words.map((word, index) => ({
    id: `${genreId}-${String(index + 1).padStart(2, "0")}`,
    genreId: genreId as WordDescriptionGenreId,
    word,
  })),
);
